import { RolPlataforma } from '../models/novedades.models';
import { routeForRole } from './roles.util';

export interface MenuItem {
  label: string;
  icon: string;
  iconAsset?: string;
  route: string;
  includeRoleParam?: boolean;
  queryParams?: Record<string, string>;
  action?: 'logout';
}

function commonMenu(rol: RolPlataforma): MenuItem[] {
  return [
    { label: 'Inicio', icon: 'house', route: routeForRole(rol), includeRoleParam: true },
    {
      label: 'Mi perfil',
      icon: 'circle-user-round',
      route: '/mi-perfil',
      includeRoleParam: true,
      queryParams: { tab: 'datos_personales' },
    },
  ];
}

const CIERRE: MenuItem = {
  label: 'Cerrar sesion',
  icon: 'log-out',
  route: '/inicio-publico',
  includeRoleParam: false,
  action: 'logout',
};

const INVITACIONES_ICON = 'assets/icons/invitaciones.png';

function invitacionesItem(): MenuItem {
  return {
    label: 'Invitaciones',
    icon: 'circle-check',
    iconAsset: INVITACIONES_ICON,
    route: '/invitaciones',
    includeRoleParam: true,
  };
}

function notificacionesItem(): MenuItem {
  return {
    label: 'Notificaciones',
    icon: 'bell',
    route: '/actualizaciones',
    includeRoleParam: true,
  };
}

export function getMenuPorRol(rol: RolPlataforma): MenuItem[] {
  if (rol === 'administrador_anid') {
    return [
      ...commonMenu(rol),
      { label: 'Gestion de usuarios', icon: 'building-2', route: '/gestion-usuarios', includeRoleParam: true },
      { label: 'Concursos', icon: 'circle-check', route: '/formularios-admin', includeRoleParam: true },
      { label: 'Monitoreo', icon: 'pie-chart', route: '/monitoreo', includeRoleParam: true },
      CIERRE,
    ];
  }

  if (rol === 'postulante') {
    return [
      ...commonMenu(rol),
      { label: 'Postulaciones', icon: 'circle-check', route: '/postulaciones', includeRoleParam: true },
      invitacionesItem(),
      notificacionesItem(),
      CIERRE,
    ];
  }

  if (rol === 'ayudante_postulante') {
    return [
      ...commonMenu(rol),
      notificacionesItem(),
      CIERRE,
    ];
  }

  if (rol === 'representante_institucional') {
    return [
      ...commonMenu(rol),
      { label: 'Patrocinio', icon: 'building-2', route: '/patrocinio', includeRoleParam: true },
      notificacionesItem(),
      CIERRE,
    ];
  }

  if (rol === 'ayudante_representante') {
    return [
      ...commonMenu(rol),
      { label: 'Patrocinio', icon: 'building-2', route: '/patrocinio', includeRoleParam: true },
      notificacionesItem(),
      CIERRE,
    ];
  }

  if (rol === 'recomendador') {
    return [
      ...commonMenu(rol),
      invitacionesItem(),
      notificacionesItem(),
      CIERRE,
    ];
  }

  if (rol === 'urc') {
    return [
      ...commonMenu(rol),
      { label: 'Postulaciones', icon: 'circle-check', route: '/postulaciones', includeRoleParam: true },
      { label: 'Monitoreo', icon: 'pie-chart', route: '/monitoreo', includeRoleParam: true },
      CIERRE,
    ];
  }

  return [
    ...commonMenu(rol),
    { label: 'Postulaciones', icon: 'circle-check', route: '/postulaciones', includeRoleParam: true },
    { label: 'Monitoreo', icon: 'pie-chart', route: '/monitoreo', includeRoleParam: true },
    CIERRE,
  ];
}
